module.exports = {
      id: "story-play-usage",
      viewBox: "0 0 35 35",
      url: __webpack_public_path__ + "svg-sprite-8e03654a4a2895e52544254db36238f1.svg#story-play",
      toString: function () {
        return this.url;
      }
    }